import * as React from "react";
import get from "lodash/get";

import "./GiftingHistory.css";
import { ComponentBase, ComponentBaseProps } from "../ComponentBase";

export interface GiftingHistoryProps extends ComponentBaseProps {
  classNames: string;
  name: string;
  configName: string;
  style?: React.CSSProperties;
  emailStyle?: React.CSSProperties;
  dateStyle?: React.CSSProperties;
  dividerStyle?: React.CSSProperties;
  completedStatusStyle?: React.CSSProperties;
  pendingStatusStyle?: React.CSSProperties;
  resendStyle?: React.CSSProperties;
  align?: "flex-start" | "flex-end" | "center" | "baseline" | "stretch";
}

export class GiftingHistory extends ComponentBase<GiftingHistoryProps> {
  render() {
    const {
      classNames,
      emailStyle,
      dateStyle,
      dividerStyle,
      completedStatusStyle,
      pendingStatusStyle,
      resendStyle,
      style,
    } = this.props;

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onMouseDown={this.onMouseDown}
        className={`GiftingHistory-container ${classNames || ""}`}
        style={{ ...style, maxHeight: get(style, "height", "inherit") }}
        aria-label="Gifting History"
        ref={(component) => (this.component = component)}
      >
        {exampleGifts.map((gift) => {
          return (
            <React.Fragment key={gift.email}>
              <div className="GiftingHistory-item">
                <div className="GiftingHistory-details">
                  <div tabIndex={0} style={emailStyle}>
                    {gift.email}
                  </div>
                  <div tabIndex={0} style={dateStyle}>
                    {gift.date}
                  </div>
                </div>
                {gift.status === "completed" && (
                  <div tabIndex={0} style={completedStatusStyle}>
                    Completed
                  </div>
                )}
                {gift.status === "pending" && (
                  <div>
                    <div tabIndex={0} style={pendingStatusStyle}>
                      Pending
                    </div>
                    <div tabIndex={0} style={resendStyle}>
                      Resend
                    </div>
                  </div>
                )}
              </div>
              <div className="GiftingHistory-divider" style={dividerStyle} />
            </React.Fragment>
          );
        })}
      </div>
    );
  }
}

const exampleGifts = [
  {
    email: "lily_klein@yahoo.com",
    date: "May 13, 2019",
    status: "completed",
  },
  {
    email: "aaron@gmail.com",
    date: "May 13, 2019",
    status: "pending",
  },
  {
    email: "lindsay19@friendbuy.com",
    date: "May 13, 2019",
    status: "completed",
  },
  {
    email: "georgie@yahoo.com",
    date: "May 10, 2019",
    status: "completed",
  },
  {
    email: "doug@freshmail.com",
    date: "May 10, 2019",
    status: "pending",
  },
  {
    email: "mom@gmail.com",
    date: "May 10, 2019",
    status: "pending",
  },
];
